import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import { type UserProps } from './UserMeStore';

class UserMeDraftStore {
  store: ReturnType<UserMeDraftStore['createStore']>;
  pendingClears: {
    userMe: boolean;
  };

  constructor() {
    this.store = this.createStore();
    this.pendingClears = {
      userMe: false,
    };
  }

  createStore() {
    return createWithEqualityFn<{ userMe?: UserProps; userMeState?: 'pending' | 'done' }>()(
      devtools(
        subscribeWithSelector((set, get, api) => {
          return {};
        }),
        {
          name: 'user-me-draft',
        },
      ),
      Object.is,
    );
  }

  get get() {
    return this.store.getState;
  }

  get set() {
    return this.store.setState;
  }

  setUserMeDraft({ userMe }: { userMe: UserProps }) {
    // TODO
    // not allowed to set draft is there is one pending.
    this.set({
      userMe,
      userMeState: 'pending',
    });
  }

  setUserMeDraftDone() {
    this.set({
      userMeState: 'done',
    });

    if (this.pendingClears.userMe === true) {
      this.set({
        userMe: undefined,
        userMeState: undefined,
      });
      this.pendingClears.userMe = false;
    }

    // TODO
    // We should set something like a max timer here that when the notify never comes the state is still cleared.
    // We can expect the update to be received within 15 seconds.
  }

  setUserMeDraftFailed() {
    this.set({
      userMe: undefined,
      userMeState: undefined,
    });
  }

  notify() {
    if (this.get().userMe != null && this.get().userMeState === 'done') {
      this.set({
        userMe: undefined,
        userMeState: undefined,
      });
    }

    if (this.get().userMe != null && this.get().userMeState === 'pending') {
      this.pendingClears.userMe = true;
    }
  }
}

export const userMeDraftStore = new UserMeDraftStore();
